<template lang="pug">
div
  transition(name="fade")
    .overlay(v-if="current")
  transition(name="apper-from-header")
    component(:is="current" @esc="$emit('close')")
</template>
<script>
import Switchsite from './Switchsite'
import Search from '../search/Search'

export default {
  props: ['current'],
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown)
  },
  methods: {
    handleKeyDown(e) {
      if (this.current && e.key === 'Escape') {
        this.$emit('close')
      }
    }
  },
  components: {
    Switchsite,
    Search
  }
}
</script>
<style>
.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #666;
  z-index: 1;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.apper-from-header-enter-active {
  animation: fade-in 0.1s;
}
.apper-from-header-leave-active {
  animation: fade-out 0.1s;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nav/NavCoverPage.vue